import { Box, Grid2, Typography } from "@mui/material";

import AlertHighlights from "../components/home/AlertHighlights";
import DeviationRatingLegends from "../components/shared/DeviationRatingLegends";
import OpenStreetMapWithMarkers from "../components/maps/OpenStreetMapWithMarkers";
import { PILOT_USER } from "../constants/PilotUser";
import PriorityDeviations from "../components/home/PriorityDeviations";
import { RESPONSIVE_HEIGHTS } from "../utils/ViewportUtils";
import { ViewportContext } from "../contexts/viewportContext";
import getGreetings from "../utils/Greetings";
import { useContext } from "react";

const VP_MIN_HEIGHT_MAPS = 650;
const VP_MIN_MAP_ZOOM_LEVEL = 6.7;

const MAP_TOP_COORDS = { lat: 70, lng: -149.8 }
const MAP_BOTTOM_COORDS = { lat: 70, lng: -149.8 }

const getZoomLevelByHeight = (height: number) => {
    if (height >= RESPONSIVE_HEIGHTS['4K'])
		return 8.5;
	if (height >= RESPONSIVE_HEIGHTS['2K'])
		return 8;

    const heightRatio = height / VP_MIN_HEIGHT_MAPS;
    const factor = heightRatio > 1 ? heightRatio * 0.4 : 0;
    return VP_MIN_MAP_ZOOM_LEVEL + factor;
};

export default function Landing() {

    const vpContext = useContext(ViewportContext);
    const getZoomLevel = getZoomLevelByHeight(vpContext?.height!);

    return (
        <Grid2
            rowSpacing={1}
            justifyContent={"center"}
            sx={{
                width: '100%',
                height: '125vh',
                boxSizing: "border-box",
                overflow: 'scroll'
            }}>
            <Grid2 size={{ lg: 4 }}
                sx={{
                    // width: { xs: '100%', lg: '475px', xl: '525px' },
                    height: 'inherit',
                    position: 'absolute',
                    top: 'max(64px, 6vh)',
                    zIndex: 12,
                    boxSizing: 'border-box',
                    display: "flex",
                    flexDirection: 'column',
                    gap: 5,
                    padding: { md: 2, xl: vpContext?.is4k ? 4 : 2 },
                    background: 'linear-gradient(to right, #F2F7F9 10%, #E7F6FF00 100%)',
                }}>
                <Box>
                    <Box sx={{
                        paddingY: 1,
                        display: "flex",
                        flexDirection: 'column',
                        alignContent: 'center',
                        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) -7.34%, rgba(255, 255, 255, 0.52) 50%)'
                    }}>
                        <Typography component={'div'}
                            variant="h4"
                            sx={{
                                height: '100%',
                                borderLeft: '0.5vw solid #41D9E1',
                                paddingX: 1,
                                textTransform: 'capitalize',
                            }}>
                            {getGreetings()} {PILOT_USER.first_name}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant={'h6'} component={'div'}
                            sx={{

                                height: '100%',
                                padding: 1,
                                lineHeight: 1,
                                marginLeft: 2,
                                fontWeight: 500
                            }}>
                            Here are the sites that need your attention
                        </Typography>
                    </Box>
                </Box>
                {/* <Grid2 sx={{
                    width: '100%',
                    height: 'max-content',
                    boxSizing: "border-box",
                    display: 'grid',
                    backdropFilter: 'blur(20px)',
                    position: 'relative'
                }}>
                    <KPITrends></KPITrends>
                </Grid2>

                <Grid2>
                    <KPITrendChart></KPITrendChart>
                </Grid2> */}
                <Grid2 sx={{
                    width: '100%',
                    height: 'max-content',
                    boxSizing: "border-box",
                    display: 'grid',
                    backdropFilter: 'blur(20px)',
                    position: 'relative',
                    borderTopRightRadius: 25,
                }}>
                    <PriorityDeviations></PriorityDeviations>
                </Grid2>
                <Grid2 sx={{
                    display: "grid",
                    gridTemplateColumns: '45% 45%',
                    gridTemplateRows: '7.5vw 7.5vw',
                    justifyContent: 'space-around',
                    placeItems: 'center',
                    gap: 2,
                    boxSizing: 'border-box'
                }}>
                    <AlertHighlights></AlertHighlights>
                </Grid2>
            </Grid2>
            <Grid2 sx={{
                width: 'inherit',
                height: 'inherit',
                overflow: 'scroll',
                position: 'absolute',
                zIndex: 1,
                top: 64,
            }}>
                {/* <MapWithLocationMarkers
                    zoomLevel={getZoomLevel}
                    center={{ lat: (MAP_TOP_COORDS.lat + MAP_BOTTOM_COORDS.lat) / 2, lng: 53.6 }}
                    ratingsOnly={['High', 'High-Medium', 'Medium']}></MapWithLocationMarkers> */}
                <OpenStreetMapWithMarkers
                    zoomLevel={getZoomLevel}
                    center={{ lat: (MAP_TOP_COORDS.lat + MAP_BOTTOM_COORDS.lat) / 2, lng: (MAP_BOTTOM_COORDS.lng + MAP_BOTTOM_COORDS.lng) / 2 }}
                    ratingsOnly={['High', 'High-Medium', 'Medium']}
                ></OpenStreetMapWithMarkers>
            </Grid2>
            <DeviationRatingLegends></DeviationRatingLegends>
        </Grid2 >
    )
}